module.exports = "/src/views/player/help/images/bus2.jpg";